import React from 'react';
import { Typography, TypographyVariant } from 'components/Typography';
import Heading from 'components/Heading';
import Avatar from 'components/Avatar';

interface AccessDeniedHeaderProps {
  title: string;
}

const AccessDeniedHeader = ({ title }: AccessDeniedHeaderProps) => (
  <div className="accessDenied__headingContainer">
    <Avatar className="accessDenied__avatar" image="avatar-male-3" />
    <Typography variant={TypographyVariant.HeaderXxs}>
      <Heading level={3} className="accessDenied__heading">
        {title}
      </Heading>
    </Typography>
  </div>
);

export default AccessDeniedHeader;
